import { render, staticRenderFns } from "./UpdateAppAlert.vue?vue&type=template&id=3775832f&scoped=true&"
import script from "./UpdateAppAlert.vue?vue&type=script&lang=js&"
export * from "./UpdateAppAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3775832f",
  null
  
)

export default component.exports